import * as Api from '@ViewModels';

/**
 * Mirrors the API's `Account.IsBoardTypeEnabled(DataboardType.Policy)` — `PoliciesEnabled ?? PolicyBoard?.Enabled`,
 * where `policiesEnabled` wins when set. That same check gates whether AMS sync writes
 * `PolicyKeyFactMetadata.PolicyId`, so it decides whether the board-backed renewal filter can resolve at all;
 * accounts without it must get the key-fact selector instead.
 */
export const isPolicyBoardEnabled = (boards?: Api.IBoardFeatures) =>
	boards?.policiesEnabled ?? boards?.policyBoard?.enabled ?? false;
